const actions = {
	LOAD_RESULTS: "LOAD_RESULTS",
	FETCH: 'FETCH',
	FETCH_HABITS: 'FETCH_HABITS',
}

export default actions